/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_viewer$ref = any;
export type PdpRespSimilarItemsGrid_viewer$ref = any;
export type PdpRespSimilarItemsGrid_viewer = {
    readonly " $fragmentRefs": PdpRespSimilarItem_viewer$ref;
    readonly " $refType": PdpRespSimilarItemsGrid_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsGrid_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItem_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '19f988926e2b264c883ba4e84213252d';
export default node;
